import angular from 'angular'
import React from 'react'
import ReactDOM from 'react-dom'

import ProofreaderSettings from '~/reactapp/Settings/ProofreaderSettings'

const templateId = 'react-ProofreaderSettings'

function Link(scope, el) {
  const rootEl = el[0]

  scope.$on('$destroy', () => ReactDOM.unmountComponentAtNode(rootEl))

  scope.vm.render = (props) => {
    ReactDOM.render(<ProofreaderSettings {...props} />, rootEl)
  }
}

function Controller() {
  const handleChange = (proofreaderSettings) => {
    this.onChange({ proofreaderSettings })
  }

  this.$onChanges = () => {
    this.render &&
      this.companySettings.proofreaders &&
      this.websites &&
      this.render({
        proofreaderSettings: this.companySettings.proofreaders,
        websites: Object.values(this.websites),
        onChange: handleChange,
      })
  }
}

function directive() {
  return {
    replace: true,
    restrict: 'E',
    controllerAs: 'vm',
    bindToController: true,
    template: `<div id="${templateId}"/>`,
    scope: {
      companySettings: '<',
      websites: '<',
      onChange: '&',
    },
    controller: Controller,
    link: Link,
  }
}

export default angular
  .module('ellipsis.proofreaderSettings', [])
  .directive('proofreaderSettings', directive)
